import './tradedefinitions';
import './stake';
import './afterpurchase';


// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/moneymanagements/binarymartingale/index.js